import React from 'react';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export default function TimestampsCell({ createdAt, updatedAt }) {
  return (
    <div style={{ fontSize: 12, lineHeight: 1.45 }}>
      <div
        style={{ color: '#0F172A', whiteSpace: 'nowrap' }}
        title={createdAt ? new Date(createdAt).toLocaleString() : ''}
      >
        <span
          style={{
            fontSize: 10,
            color: '#64748B',
            fontWeight: 600,
            textTransform: 'uppercase',
            marginRight: 5,
            letterSpacing: '0.02em',
          }}
        >
          Created:
        </span>
        <span style={{ fontWeight: 500 }}>{formatDate(createdAt)}</span>
      </div>
      <div
        style={{ color: '#475569', fontSize: 11.5, whiteSpace: 'nowrap', marginTop: 2 }}
        title={updatedAt ? new Date(updatedAt).toLocaleString() : ''}
      >
        <span
          style={{
            fontSize: 10,
            color: '#94A3B8',
            fontWeight: 600,
            textTransform: 'uppercase',
            marginRight: 5,
            letterSpacing: '0.02em',
          }}
        >
          Updated:
        </span>
        <span>{formatDate(updatedAt)}</span>
      </div>
    </div>
  );
}
